export const eventTable = {
  VIRTUAL: {
    ACTIVE: 'bille_boton_tarjeta_pausar',
    BLOCKED: 'bille_boton_tarjeta_activar'
  },
  PHYSICAL: {
    ACTIVE: 'bille_boton_tarjeta_fisica_pausar',
    BLOCKED: 'bille_boton_tarjeta_fisica_activar',
    ERROR_CREATION: 'bille_error_tarjeta_fisica_activar',
    ERROR_ASSOCIATION: 'bille_error_tarjeta_fisica_activar'
  }
}

export const scorePositionMap = {
  0: 'sin_informacion',
  1: 's1',
  2: 's2_s3',
  3: 's4',
  4: 's5'
}
